import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/app/lib/auth-guard';
import { ForgotPasswordPage } from '@/auth/pages/forgot-password';

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: () => {
    requireGuest();
  },
  component: ForgotPasswordRoute
});

function ForgotPasswordRoute() {
  return <ForgotPasswordPage/>;
}
